import React from 'react'

import { SideDrawer } from '../../../../module'
import { type SideDrawerProps } from '../../../SideDrawer/SideDrawer'

const EditCellSideDrawer = (props: SideDrawerProps) => {
  return <SideDrawer {...props} />
}

export default EditCellSideDrawer
